<div class="axis-content-wrapper">
  <div class="axis-container-fluid">
    <div>
      <img
        alt="AIG logo"
        class="aig-logo"
        src="assets/images/logos/aig-logo-blue.svg"
      />
      <span class="_sr-only">American International Group, Inc.</span>
    </div>
    <div class="initial-empty-container">
      <img
        alt=""
        class="axis-img-responsive _mlr-auto"
        src="assets/images/messages/shaking-hands.svg"
        loading="lazy"
      />
      <div
        class="axis-title"
        role="heading"
        aria-level="1"
      >
       Thanks for choosing AIG
      </div>
    
      @if (isInsured) {
        <p>
        {{insuredContent}}
        </p>
      }
        
      @if (isBroker) {
        <p>
         {{brokerContent}}
        </p>
      }
         
      <div class="axis-btn-wrapper">
        <div class="axis-btn-wrapper-center">
          @if (showPIP ) {
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadPIPInProgress"
              (click)="downloadPIPDocuments()"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text"> Download PIP Documents </span>
            </button>
            @if (downloadPIPInProgress) {
              <axis-loading class="size-small" [isInline]="true" *ngIf="downloadPIPInProgress"></axis-loading>
            }
          }
          @if (showUMUIM) {
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadUMUIMInProgress"
              (click)="downloadUMUIMDocuments()"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text"> Download UM/UIM Documents </span>
            </button>
            @if (downloadUMUIMInProgress) {
              <axis-loading class="size-small" [isInline]="true" *ngIf="downloadUMUIMInProgress"></axis-loading>
            }
          }
        </div>
      </div>
   
    </div>
  </div>
</div>
